module.exports = __webpack_public_path__ + "static/media/smiley-sticker.2b69bee1.svg";